import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { User } from '../../domain/User';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from "react-i18next";
import Can from '../../components/Can';
import { Publisher } from '../../domain/Publisher';

interface Props {
    users: User[];
    publishers: Publisher[];
    onUpdateUser: (user: User) => void;
    onPushNotificationSend: (user: User) => void;
}

const MobileUsersTable = (props: Props) => {
    const { t } = useTranslation();

    const getPublisherName = (publisherId?: number): string => {
        const publisher = props.publishers.find(p => p.id === publisherId);
        if (publisher) {
            return `${publisher.lastName} ${publisher.firstName}`;
        } else return '';
    }

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{t("name")}</TableCell>
                        <TableCell>{t("publisher")}</TableCell>
                        <Can do="manage" on='User'>
                            <TableCell>{t("actions")}</TableCell>
                        </Can>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.users.map((user: User) => (
                        <TableRow key={user.username}>
                            <TableCell>{user.username}</TableCell>
                            <TableCell>{getPublisherName(user.publisherId)}</TableCell>
                            <TableCell>
                                <Can do="manage" on='User'>
                                    <IconButton size='small' onClick={() => props.onUpdateUser(user)}>
                                        <EditIcon color="primary" />
                                    </IconButton>
                                    <Can do="manage" on='Admin'>
                                        {user.webPushSubscriptionId && <IconButton size='small' onClick={() => props.onPushNotificationSend(user)}>
                                            <SendIcon color="secondary" />
                                        </IconButton>}
                                    </Can>
                                </Can>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MobileUsersTable;